import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from 'shared/core';
import { TenantContextService } from 'shared/core';

@Component({
    selector: 'app-payment-blocked',
    templateUrl: './payment-blocked.component.html',
    standalone: false
})
export class PaymentBlockedComponent implements OnInit {

  constructor(
    private router: Router,
    private msalService: MsalService,
    private authService: AuthService,
    private tenantContextService: TenantContextService
  ) { }

  ngOnInit() {
  }

  // Logs the user out and redirects to login page
  // Clear only app-specific keys instead of wiping all localStorage
  logout() {
    this.authService.clearLocalDataStorage();
    this.tenantContextService.clearTenantContext();
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/'
    });
  }
}
